import { SearchInputFileConfig } from '../components/mercer-mind-search-input/interfaces/search-input-file-config.interface';

export const FileUploadConfig: SearchInputFileConfig = {
    tooltipMessage:
        'Upload a PDF or Word file (up to 2MB). Your document will be used solely for this chat, and no data will be saved or retained for any other purposes.',
    fileTypes: '.pdf, .doc, .docx',
    fileMaxSize: 1024 * 2,
};
